import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = {
  key: 4,
  class: "flex items-center",
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_7 = {
  key: 5,
  class: "flex items-center",
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_8 = { class: "link" }
const _hoisted_9 = { class: "link" }
const _hoisted_10 = { class: "link" }
const _hoisted_11 = { class: "link" }
const _hoisted_12 = { class: "link" }
const _hoisted_13 = { class: "link" }
const _hoisted_14 = { class: "link" }
const _hoisted_15 = {
  key: 0,
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_16 = ["alt", "src"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = {
  key: 4,
  class: "flex items-center",
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_21 = {
  key: 5,
  class: "flex items-center",
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_22 = {
  key: 0,
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_23 = ["alt", "src"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = {
  key: 4,
  class: "flex items-center",
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_28 = {
  key: 5,
  class: "flex items-center",
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("b", null, "Total:", -1)
const _hoisted_31 = { class: "link" }
const _hoisted_32 = { class: "link" }
const _hoisted_33 = { class: "link" }
const _hoisted_34 = { class: "link" }
const _hoisted_35 = { class: "link" }
const _hoisted_36 = { class: "link" }
const _hoisted_37 = { class: "link" }
const _hoisted_38 = { class: "link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_table, {
      dark: "",
      rows: _ctx.rows,
      "rows-per-page-options": [5, 10, 30, 50, 100, 0],
      expanded: _ctx.expandedKeys,
      "onUpdate:expanded": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.expandedKeys) = $event)),
      dense: "",
      "column-sort-order": "da",
      columns: _ctx.columns,
      "visible-columns": _ctx.visibleColumns,
      "row-key": "id",
      separator: "cell",
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pagination) = $event)),
      loading: _ctx.loading,
      onRequest: _ctx.onRequest,
      "binary-state-sort": "",
      class: "table-with-min-height-row"
    }, _createSlots({
      top: _withCtx(() => [
        _createVNode(_component_q_select, {
          modelValue: _ctx.visibleColumns,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visibleColumns) = $event)),
          multiple: "",
          outlined: "",
          dense: "",
          "options-dense": "",
          "display-value": _ctx.$t('tables.statistic.column'),
          "emit-value": "",
          "map-options": "",
          options: _ctx.columns,
          "option-value": "name",
          "option-label": "fullLabel",
          "options-cover": "",
          style: {"min-width":"150px"}
        }, null, 8, ["modelValue", "display-value", "options"]),
        _createVNode(_component_q_btn, {
          "no-caps": "",
          icon: "autorenew",
          style: {"padding":"11px 13px","margin-left":"12px"},
          label: _ctx.$t('tables.statistic.reset'),
          class: "white-btn",
          color: "primary",
          onClick: _ctx.resetColumns,
          outline: ""
        }, null, 8, ["label", "onClick"])
      ]),
      header: _withCtx((props) => [
        _createVNode(_component_q_tr, null, {
          default: _withCtx(() => [
            (_ctx.getDateSlot)
              ? (_openBlock(), _createBlock(_component_q_th, {
                  key: "groupByField",
                  props: props,
                  rowspan: "2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getGroupedField('name')), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]))
              : _createCommentVNode("", true),
            (_ctx.getTrafficSlot)
              ? (_openBlock(), _createBlock(_component_q_th, {
                  key: 1,
                  colspan: _ctx.getTrafficSlot
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.traf')), 1)
                  ]),
                  _: 1
                }, 8, ["colspan"]))
              : _createCommentVNode("", true),
            (_ctx.getRegsSlot)
              ? (_openBlock(), _createBlock(_component_q_th, {
                  key: 2,
                  rowspan: "2",
                  colspan: _ctx.getRegsSlot
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.reg')), 1)
                  ]),
                  _: 1
                }, 8, ["colspan"]))
              : _createCommentVNode("", true),
            (_ctx.getDepositsSlot)
              ? (_openBlock(), _createBlock(_component_q_th, {
                  key: 3,
                  colspan: _ctx.getDepositsSlot
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.dep1')), 1)
                  ]),
                  _: 1
                }, 8, ["colspan"]))
              : _createCommentVNode("", true),
            (_ctx.getFinancesSlot)
              ? (_openBlock(), _createBlock(_component_q_th, {
                  key: 4,
                  colspan: _ctx.getFinancesSlot
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.prof')), 1)
                  ]),
                  _: 1
                }, 8, ["colspan"]))
              : _createCommentVNode("", true),
            (_ctx.getDDepositsSlot)
              ? (_openBlock(), _createBlock(_component_q_th, {
                  key: 5,
                  colspan: _ctx.getDDepositsSlot
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.nextDep')), 1)
                  ]),
                  _: 1
                }, 8, ["colspan"]))
              : _createCommentVNode("", true),
            (_ctx.getConversionSlot)
              ? (_openBlock(), _createBlock(_component_q_th, {
                  key: 6,
                  colspan: _ctx.getConversionSlot
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.conv')), 1)
                  ]),
                  _: 1
                }, 8, ["colspan"]))
              : _createCommentVNode("", true),
            (_ctx.getCrSlot)
              ? (_openBlock(), _createBlock(_component_q_th, {
                  key: 7,
                  colspan: _ctx.getCrSlot
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.pok')), 1)
                  ]),
                  _: 1
                }, 8, ["colspan"]))
              : _createCommentVNode("", true),
            (_ctx.getRevShareSlot)
              ? (_openBlock(), _createBlock(_component_q_th, {
                  key: 8,
                  colspan: "2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.rev')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_q_tr, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
              'left-border': true,
            }),
              key: "clicks",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.click')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "uniqueClicks",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.unik')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "registrationCount",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.amount')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "firstDepositCount",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.amount')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "firstDepositSum",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.sum')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "approvedSum",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.approve')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "holdSum",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.hold')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "rejectedSum",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.cancel')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "depositCount",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.quantity')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "depositSum",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.sum')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "uniqueDepositCount",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.unik1')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "approvedLeads",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.approve')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "holdLeads",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.hold')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "rejectedLeads",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.cancel')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "epc",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.epc')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "crUniqueReg",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.uniqreg')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "cr",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.uniqdep')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "crFtdReg",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.regdep')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "approvedPercent",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.approve1')), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_th, {
              class: _normalizeClass({
              'pointer-cursor': true,
            }),
              key: "revShareRevenueSum",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.statistic.income')), 1)
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 2
        }, 1024)
      ]),
      loading: _withCtx(() => [
        _createVNode(_component_q_inner_loading, {
          showing: "",
          color: "white",
          style: {"background":"#4c3d3d45"}
        })
      ]),
      body: _withCtx((props) => [
        _createVNode(_component_q_tr, {
          props: props,
          style: _normalizeStyle(
            this.expandedIds.includes(props.row.id) ? 'background: black' : ''
          )
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_td, {
              props: props,
              key: "groupByField"
            }, {
              default: _withCtx(() => [
                (_ctx.filters.groupBy === 'geoId')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                      _createElementVNode("img", {
                        style: {"user-select":"none","display":"initial"},
                        class: "q-mr-xs",
                        height: "10",
                        width: "15",
                        alt: props.row.geoCode,
                        src: 
                  `http://purecatamphetamine.github.io/country-flag-icons/3x2/${props.row.geoCode}.svg`
                
                      }, null, 8, _hoisted_2),
                      _createTextVNode(" " + _toDisplayString(props.row.geoCode || '??') + " ", 1),
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getGroupedField('field', props.row) || 'Неизвестно'), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.filters.groupBy === 'date')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.formatDateLikeChart(_ctx.getGroupedField('field', props.row))), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.filters.groupBy !== 'week' &&
                  _ctx.filters.groupBy !== 'date' &&
                  _ctx.filters.groupBy !== 'geoId' &&
                  _ctx.filters.groupBy !== 'affiliateId' &&
                  _ctx.filters.groupBy !== 'offerId'
              )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.getGroupedField('field', props.row) || 'Неизвестно'), 1))
                  : _createCommentVNode("", true),
                (_ctx.filters.groupBy === 'week')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.getISOWeekName(_ctx.getGroupedField('field', props.row))), 1))
                  : _createCommentVNode("", true),
                (_ctx.filters.groupBy === 'offerId')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createTextVNode(_toDisplayString(_ctx.getGroupedField('field', props.row) || 'Неизвестно') + " ", 1),
                      _createVNode(_component_q_icon, {
                        class: "q-ml-xs",
                        size: "18px",
                        color: "grey",
                        name: "casino"
                      }),
                      (_ctx.filters.groupBy2)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            class: "q-ml-sm",
                            size: "sm",
                            dense: "",
                            flat: "",
                            onClick: ($event: any) => (_ctx.onExpandRow(props.row)),
                            icon: 
                  this.expandedIds.includes(props.row.id)
                    ? 'arrow_drop_up'
                    : 'arrow_drop_down'
                
                          }, null, 8, ["onClick", "icon"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.filters.groupBy === 'affiliateId')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_ctx.getGroupedField('field', props.row) || 'Неизвестно') + " ", 1),
                      _createVNode(_component_q_icon, {
                        class: "q-ml-xs",
                        size: "21px",
                        color: "secondary",
                        name: "account_box"
                      }),
                      _createTextVNode("#" + _toDisplayString(props.row.affiliateId) + " ", 1),
                      (_ctx.filters.groupBy2)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            class: "q-ml-sm",
                            size: "sm",
                            dense: "",
                            flat: "",
                            onClick: ($event: any) => (_ctx.onExpandRow(props.row)),
                            icon: 
                  this.expandedIds.includes(props.row.id)
                    ? 'arrow_drop_up'
                    : 'arrow_drop_down'
                
                          }, null, 8, ["onClick", "icon"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (
                _ctx.filters.groupBy2 &&
                  _ctx.filters.groupBy !== 'affiliateId' &&
                  _ctx.filters.groupBy !== 'offerId'
              )
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 6,
                      class: "q-ml-sm",
                      size: "sm",
                      dense: "",
                      flat: "",
                      onClick: ($event: any) => (_ctx.onExpandRow(props.row)),
                      icon: 
                this.expandedIds.includes(props.row.id)
                  ? 'arrow_drop_up'
                  : 'arrow_drop_down'
              
                    }, null, 8, ["onClick", "icon"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "clicks",
              props: props,
              onClick: _withModifiers(($event: any) => (
              _ctx.detailClicks({ [_ctx.filters.groupBy]: props.row[_ctx.filters.groupBy] })
            ), ["stop"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, _toDisplayString(props.row.clicks || 0), 1)
              ]),
              _: 2
            }, 1032, ["props", "onClick"]),
            _createVNode(_component_q_td, {
              key: "uniqueClicks",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(props.row.uniqueClicks || 0), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "registrationCount",
              props: props,
              onClick: _withModifiers(($event: any) => (
              _ctx.detailConversions({
                [_ctx.filters.groupBy]: props.row[_ctx.filters.groupBy],
              })
            ), ["stop"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, _toDisplayString(props.row.registrationCount || 0), 1)
              ]),
              _: 2
            }, 1032, ["props", "onClick"]),
            _createVNode(_component_q_td, {
              key: "firstDepositCount",
              props: props,
              onClick: _withModifiers(($event: any) => (
              _ctx.detailConversions({
                [_ctx.filters.groupBy]: props.row[_ctx.filters.groupBy],
                rewardTypes: [_ctx.rewardType.FTD, _ctx.rewardType.CPA],
              })
            ), ["stop"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, _toDisplayString(props.row.firstDepositCount || 0), 1)
              ]),
              _: 2
            }, 1032, ["props", "onClick"]),
            _createVNode(_component_q_td, {
              key: "firstDepositSum",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.firstDepositSum)), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "approvedSum",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.isMB
                  ? _ctx.formatProfit(
                      Number(props.row.approvedSum) + Number(props.row.holdSum),
                    )
                  : _ctx.formatColumnValue(props.row.approvedSum)), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "holdSum",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.holdSum)), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "rejectedSum",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatProfit(_ctx.formatColumnValue(props.row.rejectedSum))), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              props: props,
              key: "depositCount"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, _toDisplayString(props.row.depositCount || 0), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "depositSum",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.depositSum || 0)), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "uniqueDepositCount",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(props.row.uniqueDepositCount || 0), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "approvedLeads",
              props: props,
              onClick: _withModifiers(($event: any) => (
              _ctx.detailConversions({
                status: _ctx.leadStatus.Approved,
                [_ctx.filters.groupBy]: props.row[_ctx.filters.groupBy],
              })
            ), ["stop"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.isMB
                  ? (Number(props.row.approvedLeads) || 0) +
                    (Number(props.row.holdLeads) || 0)
                  : props.row.approvedLeads), 1)
              ]),
              _: 2
            }, 1032, ["props", "onClick"]),
            _createVNode(_component_q_td, {
              key: "holdLeads",
              props: props,
              onClick: _withModifiers(($event: any) => (
              _ctx.detailConversions({
                status: _ctx.leadStatus.Hold,
                [_ctx.filters.groupBy]: props.row[_ctx.filters.groupBy],
              })
            ), ["stop"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, _toDisplayString(props.row.holdLeads), 1)
              ]),
              _: 2
            }, 1032, ["props", "onClick"]),
            _createVNode(_component_q_td, {
              key: "rejectedLeads",
              props: props,
              onClick: _withModifiers(($event: any) => (
              _ctx.detailConversions({
                status: _ctx.leadStatus.Rejected,
                [_ctx.filters.groupBy]: props.row[_ctx.filters.groupBy],
              })
            ), ["stop"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, _toDisplayString(props.row.rejectedLeads), 1)
              ]),
              _: 2
            }, 1032, ["props", "onClick"]),
            _createVNode(_component_q_td, {
              key: "epc",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.epc)), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "crUniqueReg",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.crUniqueReg)), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "cr",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.cr)), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "crFtdReg",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.crFtdReg)), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "approvedPercent",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.approvedPercent)), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "revShareRevenueSum",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.revShareRevenueSum)), 1)
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 2
        }, 1032, ["props", "style"]),
        (this.expandedIds.includes(props.row.id))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.children, (child, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createVNode(_component_q_tr, {
                    style: {"background":"#484746"},
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_td, {
                        props: props,
                        key: "groupByField"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.filters.groupBy2 === 'geoId')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                _createElementVNode("img", {
                                  style: {"user-select":"none","display":"initial"},
                                  class: "q-mr-xs",
                                  height: "10",
                                  width: "15",
                                  alt: props.row.children?.[index].geoCode,
                                  src: 
                      `http://purecatamphetamine.github.io/country-flag-icons/3x2/${props.row.children?.[index].geoCode}.svg`
                    
                                }, null, 8, _hoisted_16),
                                _createTextVNode(" " + _toDisplayString(props.row.children?.[index].geoCode || '??') + " ", 1),
                                _createVNode(_component_q_tooltip, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getGroupedField2('field', props.row.children?.[index]) ||
                      'Неизвестно'), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.filters.groupBy2 === 'date')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.formatDateLikeChart(
                      _ctx.getGroupedField2('field', props.row.children?.[index]),
                    )), 1))
                            : _createCommentVNode("", true),
                          (
                    _ctx.filters.groupBy2 !== 'week' &&
                      _ctx.filters.groupBy2 !== 'date' &&
                      _ctx.filters.groupBy2 !== 'geoId' &&
                      _ctx.filters.groupBy2 !== 'affiliateId' &&
                      _ctx.filters.groupBy2 !== 'offerId'
                  )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.getGroupedField2('field', props.row.children?.[index]) ||
                      'Неизвестно'), 1))
                            : _createCommentVNode("", true),
                          (_ctx.filters.groupBy2 === 'week')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.getISOWeekName(
                      _ctx.getGroupedField2('field', props.row.children?.[index]),
                    )), 1))
                            : _createCommentVNode("", true),
                          (_ctx.filters.groupBy2 === 'offerId')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                _createTextVNode(_toDisplayString(_ctx.getGroupedField2('field', props.row.children?.[index]) ||
                      _ctx.$t('tables.statistic.unknown')) + " ", 1),
                                _createVNode(_component_q_icon, {
                                  class: "q-ml-xs",
                                  size: "18px",
                                  color: "grey",
                                  name: "casino"
                                }),
                                (_ctx.filters.groupBy3)
                                  ? (_openBlock(), _createBlock(_component_q_btn, {
                                      key: 0,
                                      class: "q-ml-sm",
                                      size: "sm",
                                      dense: "",
                                      flat: "",
                                      onClick: ($event: any) => (_ctx.onExpandRow(props.row.children?.[index])),
                                      icon: 
                      this.expandedIds.includes(props.row.children?.[index].id)
                        ? 'arrow_drop_up'
                        : 'arrow_drop_down'
                    
                                    }, null, 8, ["onClick", "icon"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.filters.groupBy2 === 'affiliateId')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                _createTextVNode(_toDisplayString(_ctx.getGroupedField2('field', props.row.children?.[index]) ||
                      _ctx.$t('tables.statistic.unknown')) + " ", 1),
                                _createVNode(_component_q_icon, {
                                  class: "q-ml-xs",
                                  size: "21px",
                                  color: "secondary",
                                  name: "account_box"
                                }),
                                _createTextVNode("#" + _toDisplayString(props.row.children?.[index].affiliateId) + " ", 1),
                                (_ctx.filters.groupBy3)
                                  ? (_openBlock(), _createBlock(_component_q_btn, {
                                      key: 0,
                                      class: "q-ml-sm",
                                      size: "sm",
                                      dense: "",
                                      flat: "",
                                      onClick: ($event: any) => (_ctx.onExpandRow(props.row.children?.[index])),
                                      icon: 
                      this.expandedIds.includes(props.row.children?.[index].id)
                        ? 'arrow_drop_up'
                        : 'arrow_drop_down'
                    
                                    }, null, 8, ["onClick", "icon"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (
                    _ctx.filters.groupBy3 &&
                      _ctx.filters.groupBy2 !== 'affiliateId' &&
                      _ctx.filters.groupBy2 !== 'offerId'
                  )
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 6,
                                class: "q-ml-sm",
                                size: "sm",
                                dense: "",
                                flat: "",
                                onClick: ($event: any) => (_ctx.onExpandRow(props.row.children?.[index])),
                                icon: 
                    this.expandedIds.includes(props.row.children?.[index].id)
                      ? 'arrow_drop_up'
                      : 'arrow_drop_down'
                  
                              }, null, 8, ["onClick", "icon"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "clicks",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].clicks || 0), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "uniqueClicks",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].uniqueClicks || 0), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "registrationCount",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].registrationCount || 0), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "firstDepositCount",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].firstDepositCount || 0), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "firstDepositSum",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(
                      props.row.children?.[index].firstDepositSum,
                    )), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "approvedSum",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.isMB
                      ? _ctx.formatProfit(
                          Number(props.row.children?.[index].approvedSum) +
                            Number(props.row.children?.[index].holdSum),
                        )
                      : _ctx.formatColumnValue(
                          props.row.children?.[index].approvedSum,
                        )), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "holdSum",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.children?.[index].holdSum)), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "rejectedSum",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.formatProfit(
                      _ctx.formatColumnValue(
                        props.row.children?.[index].rejectedSum,
                      ),
                    )), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        props: props,
                        key: "depositCount"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].depositCount || 0), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "depositSum",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.children?.[index].depositSum)), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "uniqueDepositCount",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].uniqueDepositCount || 0), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "approvedLeads",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.isMB
                      ? (Number(props.row.children?.[index].approvedLeads) ||
                          0) +
                        (Number(props.row.children?.[index].holdLeads) || 0)
                      : props.row.children?.[index].approvedLeads), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "holdLeads",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].holdLeads), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "rejectedLeads",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].rejectedLeads), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "epc",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.children?.[index].epc)), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "crUniqueReg",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.children?.[index].crUniqueReg)), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "cr",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.children?.[index].cr)), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "crFtdReg",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(props.row.children?.[index].crFtdReg)), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "approvedPercent",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(
                      props.row.children?.[index].approvedPercent,
                    )), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "revShareRevenueSum",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(
                      props.row.children?.[index].revShareRevenueSum,
                    )), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"])
                    ]),
                    _: 2
                  }, 1032, ["props"]),
                  (this.expandedIds.includes(child.id))
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(child.children, (child2, index2) => {
                        return (_openBlock(), _createBlock(_component_q_tr, {
                          style: {"background":"rgba(139,109, 71, 0.6)"},
                          props: props,
                          key: index2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_td, {
                              props: props,
                              key: "groupByField",
                              class: "text-right"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.filters.groupBy3 === 'geoId')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                      _createElementVNode("img", {
                                        style: {"user-select":"none","display":"initial"},
                                        class: "q-mr-xs",
                                        height: "10",
                                        width: "15",
                                        alt: 
                        props.row.children?.[index].children?.[index2].geoCode
                      ,
                                        src: 
                        `http://purecatamphetamine.github.io/country-flag-icons/3x2/${props.row.children?.[index].children?.[index2].geoCode}.svg`
                      
                                      }, null, 8, _hoisted_23),
                                      _createTextVNode(" " + _toDisplayString(props.row.children?.[index].children?.[index2].geoCode ||
                        '??') + " ", 1),
                                      _createVNode(_component_q_tooltip, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getGroupedField3(
                        'field',
                        props.row.children?.[index].children?.[index2],
                      ) || _ctx.$t('tables.statistic.unknown')), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.filters.groupBy3 === 'date')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.formatDateLikeChart(
                        _ctx.getGroupedField3(
                          'field',
                          props.row.children?.[index].children?.[index2],
                        ),
                      )), 1))
                                  : _createCommentVNode("", true),
                                (
                      _ctx.filters.groupBy3 !== 'week' &&
                        _ctx.filters.groupBy3 !== 'date' &&
                        _ctx.filters.groupBy3 !== 'geoId' &&
                        _ctx.filters.groupBy3 !== 'affiliateId' &&
                        _ctx.filters.groupBy3 !== 'offerId'
                    )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.getGroupedField3(
                        'field',
                        props.row.children?.[index].children?.[index2],
                      ) || _ctx.$t('tables.statistic.unknown')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.filters.groupBy3 === 'week')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.getISOWeekName(
                        _ctx.getGroupedField3(
                          'field',
                          props.row.children?.[index].children?.[index2],
                        ),
                      )), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.filters.groupBy3 === 'offerId')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                      _createTextVNode(_toDisplayString(_ctx.getGroupedField3(
                        'field',
                        props.row.children?.[index].children?.[index2],
                      ) || _ctx.$t('tables.statistic.unknown')) + " ", 1),
                                      _createVNode(_component_q_icon, {
                                        class: "q-ml-xs",
                                        size: "18px",
                                        color: "grey",
                                        name: "casino"
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.filters.groupBy3 === 'affiliateId')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                      _createTextVNode(_toDisplayString(_ctx.getGroupedField3(
                        'field',
                        props.row.children?.[index].children?.[index2],
                      ) || _ctx.$t('tables.statistic.unknown')) + " ", 1),
                                      _createVNode(_component_q_icon, {
                                        class: "q-ml-xs",
                                        size: "21px",
                                        color: "secondary",
                                        name: "account_box"
                                      }),
                                      _createTextVNode("#" + _toDisplayString(props.row.children?.[index].children?.[index2].affiliateId), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "clicks",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].children?.[index2].clicks || 0), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "uniqueClicks",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].children?.[index2]
                        .uniqueClicks || 0), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "registrationCount",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].children?.[index2]
                        .registrationCount || 0), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "firstDepositCount",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].children?.[index2]
                        .firstDepositCount || 0), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "firstDepositSum",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(
                        props.row.children?.[index].children?.[index2]
                          .firstDepositSum,
                      )), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "approvedSum",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.isMB
                        ? _ctx.formatProfit(
                            Number(
                              props.row.children?.[index].children?.[index2]
                                .approvedSum,
                            ) +
                              Number(
                                props.row.children?.[index].children?.[index2]
                                  .holdSum,
                              ),
                          )
                        : _ctx.formatColumnValue(
                            props.row.children?.[index].children?.[index2]
                              .approvedSum,
                          )), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "holdSum",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(
                        props.row.children?.[index].children?.[index2].holdSum,
                      )), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "rejectedSum",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.formatProfit(
                        _ctx.formatColumnValue(
                          props.row.children?.[index].children?.[index2]
                            .rejectedSum,
                        ),
                      )), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              props: props,
                              key: "depositCount"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].children?.[index2]
                        .depositCount || 0), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "depositSum",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(
                        props.row.children?.[index].children?.[index2]
                          .depositSum,
                      )), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "uniqueDepositCount",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].children?.[index2]
                        .uniqueDepositCount || 0), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "approvedLeads",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.isMB
                        ? (Number(
                            props.row.children?.[index].children?.[index2]
                              .approvedLeads,
                          ) || 0) +
                          (Number(
                            props.row.children?.[index].children?.[index2]
                              .holdLeads,
                          ) || 0)
                        : props.row.children?.[index].children?.[index2]
                            .approvedLeads), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "holdLeads",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].children?.[index2].holdLeads), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "rejectedLeads",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(props.row.children?.[index].children?.[index2]
                        .rejectedLeads), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "epc",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(
                        props.row.children?.[index].children?.[index2].epc,
                      )), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "crUniqueReg",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(
                        props.row.children?.[index].children?.[index2]
                          .crUniqueReg,
                      )), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "cr",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(
                        props.row.children?.[index].children?.[index2].cr,
                      )), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "crFtdReg",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(
                        props.row.children?.[index].children?.[index2].crFtdReg,
                      )), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "approvedPercent",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(
                        props.row.children?.[index].children?.[index2]
                          .approvedPercent,
                      )), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "revShareRevenueSum",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.formatColumnValue(
                        props.row.children?.[index].children?.[index2]
                          .revShareRevenueSum,
                      )), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"])
                          ]),
                          _: 2
                        }, 1032, ["props"]))
                      }), 128))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              _createVNode(_component_q_tr, { props: props }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_td, { colspan: "100%" }, {
                    default: _withCtx(() => [
                      _hoisted_29
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["props"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.rows?.length)
        ? {
            name: "bottom-row",
            fn: _withCtx(() => [
              _createVNode(_component_q_tr, null, {
                default: _withCtx(() => [
                  (_ctx.getDateSlot)
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 0,
                        class: "text-center",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('clicks'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 1,
                        class: "text-right",
                        colspan: "1",
                        onClick: _withModifiers(_ctx.detailClicks, ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.total('clicks', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (
              _ctx.filters.groupBy !== 'date' &&
                _ctx.filters.groupBy !== 'week' &&
                _ctx.visibleColumns.includes('clicksDelta')
            )
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 2,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.total('clicksDelta', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('uniqueClicks'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 3,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.total('uniqueClicks', 'sum')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
              _ctx.filters.groupBy !== 'date' &&
                _ctx.filters.groupBy !== 'week' &&
                _ctx.visibleColumns.includes('uniqueClicksDelta')
            )
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 4,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.total('uniqueClicksDelta', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('registrationCount'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 5,
                        class: "text-right",
                        colspan: "1",
                        onClick: _withModifiers(_ctx.detailConversions, ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.total('registrationCount', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (
              _ctx.filters.groupBy !== 'date' &&
                _ctx.filters.groupBy !== 'week' &&
                _ctx.visibleColumns.includes('registrationCountDelta')
            )
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 6,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.total('registrationCountDelta', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('firstDepositCount'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 7,
                        class: "text-right",
                        colspan: "1",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
              _ctx.detailConversions({
                rewardTypes: [_ctx.rewardType.FTD, _ctx.rewardType.CPA],
              })
            ), ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.total('firstDepositCount', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
              _ctx.filters.groupBy !== 'date' &&
                _ctx.filters.groupBy !== 'week' &&
                _ctx.visibleColumns.includes('firstDepositCountDelta')
            )
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 8,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.total('firstDepositCountDelta', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('firstDepositSum'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 9,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.total('firstDepositSum', 'sum')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('approvedSum'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 10,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.isMB
                ? _ctx.formatProfit(
                    Number(_ctx.total('approvedSum', 'sum')) +
                      Number(_ctx.total('holdSum', 'sum')),
                  )
                : _ctx.total('approvedSum', 'sum')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('holdSum'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 11,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.total('holdSum', 'sum')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('rejectedSum'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 12,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.formatProfit(_ctx.total('rejectedSum', 'sum'))), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('depositCount'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 13,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.total('depositCount', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('depositSum'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 14,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.total('depositSum', 'sum')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('uniqueDepositCount'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 15,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.total('uniqueDepositCount', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('approvedLeads'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 16,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.isMB
                  ? Number(_ctx.total('approvedLeads', 'sum')) +
                    Number(_ctx.total('holdLeads', 'sum'))
                  : _ctx.total('approvedLeads', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('holdLeads'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 17,
                        class: "text-right",
                        colspan: "1",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.detailConversions({ status: _ctx.leadStatus.Hold })), ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.total('holdLeads', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('rejectedLeads'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 18,
                        class: "text-right",
                        colspan: "1",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.detailConversions({ status: _ctx.leadStatus.Rejected })), ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.total('rejectedLeads', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
              _ctx.filters.groupBy !== 'date' &&
                _ctx.filters.groupBy !== 'week' &&
                _ctx.visibleColumns.includes('approvedLeadsDelta')
            )
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 19,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.total('approvedLeadsDelta', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
              _ctx.filters.groupBy !== 'date' &&
                _ctx.filters.groupBy !== 'week' &&
                _ctx.visibleColumns.includes('holdLeadsDelta')
            )
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 20,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.total('holdLeadsDelta', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
              _ctx.filters.groupBy !== 'date' &&
                _ctx.filters.groupBy !== 'week' &&
                _ctx.visibleColumns.includes('rejectedLeadsDelta')
            )
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 21,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.total('rejectedLeadsDelta', 'sum')), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('epc'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 22,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.total('epc', 'avg')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('crUniqueReg'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 23,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.totalCrUniqueReg), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('cr'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 24,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.total('cr', 'avg')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('crFtdReg'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 25,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.totalCrFtdReg), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.visibleColumns.includes('approvedPercent'))
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 26,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.total('approvedPercent', 'avg')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.getRevShareSlot)
                    ? (_openBlock(), _createBlock(_component_q_td, {
                        key: 27,
                        class: "text-right",
                        colspan: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.total('revShareRevenueSum', 'sum')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["rows", "expanded", "columns", "visible-columns", "pagination", "loading", "onRequest"])
  ]))
}